// @ts-nocheck
import { useState, useEffect, useRef } from "react";
import { Button, Input, Form, Select, Flex } from 'antd';
import AdminDashboard from "./admin-dashboard";

const secretKey = "dumbsecretkey"
async function getUserToken() {
  await new Promise(resolve => setTimeout(resolve, 400));
  return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEyLCJpc0FkbWluIjpmYWxzZSwiZXhwIjoxNzc1MDg5NzYzfQ.p06_4ZHHND5rxw8kjPVjv6kGjLNtuTfiLU8XKHPxolo"
  // return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEyLCJpc0FkbWluIjp0cnVlLCJleHAiOjE3NzUwNjk5NDh9.oTxQSCPgPbKHiDRxoSpVhi1esG545oB2AgQYVqAkJsg"
}

const base64urlDecode = (str: any) => {
  str = str.replace(/-/g, "+").replace(/_/g, "/");
  const pad = str.length % 4 ? 4 - (str.length % 4) : 0;
  const base64 = str + "=".repeat(pad);
  const bin = atob(base64);

  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes.buffer;
}


async function verifyAndParseToken(token: any, secret: any) {
  let errors = [];
  let payload;
  const [headerB64, payloadB64, signatureB64 = ""] = token.split(".");
  const header = JSON.parse(new TextDecoder().decode(base64urlDecode(headerB64)));
  const alg = `SHA-${header.alg.substring(2)}`;
  const data = `${headerB64}.${payloadB64}`;
  const key = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(secret),
    { name: "HMAC", hash: { name: alg } },
    false,
    ["verify"]
  );

  const signature = base64urlDecode(signatureB64);
  const valid = await crypto.subtle.verify("HMAC", key, signature, new TextEncoder().encode(data));
  if (!valid) {
    errors.push("Invalid signature");
  }

  payload = JSON.parse(new TextDecoder().decode(base64urlDecode(payloadB64)));
  if (payload.exp && Date.now() / 1000 > payload.exp) {
    errors.push("Token expired");
  }
  return { errors, payload, algorithm: header.alg };
}



async function getUserRole() {
  const token = await getUserToken();
  const { payload, errors } = await verifyAndParseToken(token, secretKey);
  return payload.isAdmin ? "admin" : "user";

}

const Admin = () => {
  const [isAdmin, setIsAdmin] = useState(null);

  const verify = async (values: any) => {
    const v = await getUserRole();
    setIsAdmin(v === "admin")
  };

  if (isAdmin === true) {
    return <AdminDashboard />
  }

  return (
    <div className="h-full overflow-auto">
      {isAdmin === false && <h2 style={{ color: "red" }}>You must be and admin</h2>}
      <Button onClick={verify}>
        Goto Admin Dashboard
      </Button>
    </div>

  );
}



export default Admin;